var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66667 0C2.98477 0 0 2.98477 0 6.66667C0 10.3486 2.98477 13.3333 6.66667 13.3333C10.3486 13.3333 13.3333 10.3486 13.3333 6.66667C13.3291 2.98651 10.3468 0.00421022 6.66667 0ZM6.66667 12C3.72115 12 1.33333 9.61219 1.33333 6.66667C1.33333 3.72115 3.72115 1.33333 6.66667 1.33333C9.61219 1.33333 12 3.72115 12 6.66667C11.9966 9.61079 9.61079 11.9966 6.66667 12ZM6.19521 2.86188C6.32025 2.73684 6.48984 2.66662 6.66667 2.66667C6.84349 2.66662 7.01309 2.73684 7.13812 2.86188C7.26316 2.98691 7.33338 3.15651 7.33333 3.33333V6.66667C7.33324 6.77646 7.30619 6.88455 7.25456 6.98145L6.25456 8.84733C6.08071 9.17202 5.67657 9.29429 5.35189 9.12045C5.0272 8.9466 4.90492 8.54246 5.07877 8.21777L6 6.49933V3.33333C5.99995 3.15651 6.07018 2.98691 6.19521 2.86188Z",
    fill: "#2E5DE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.708b322a0b7e2a791cb8d5790ebcacc5.svg";
export { ForwardRef as ReactComponent };